import { render } from "./ToggleSwitch.vue?vue&type=template&id=9e30793a&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=9e30793a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e30793a"

export default script